import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { ApplicationDialogComponent } from './application-dialog/application-dialog.component';
import { ApplicationListComponent } from './application-list/application-list.component';
import { ApplicationSelectComponent } from './application-select/application-select.component';

@NgModule({
  declarations: [
    ApplicationDialogComponent,
    ApplicationListComponent,
    ApplicationSelectComponent
  ],
  imports: [
    SharedModule
  ],
  exports: [
    ApplicationSelectComponent
  ]
})
export class ApplicationsModule { }
